export default __webpack_public_path__ + "static/media/activity_3.42e8a3ab.png";